export default __webpack_public_path__ + "static/media/uploader-abbottXtra-problem-1.80d96dbc.png";